export default "__VITE_ASSET__Bdw6G$1B__"